<a (click)="downloadDocument()"
  class="btn btn--link btn--link--secondary btn--link--secondary--icon btn--link--secondary--color p-0 display-flex">
  <img src="assets/img/link.png" class="align-image" alt=""> Ver
  documento
  <div class="decorator-container" [ngClass]="shouldShowLoadingAnimation ? '' : 'global-unmount'">
    <div class="loader-container">
      <app-loader></app-loader>
    </div>
  </div>
</a>
<div class="form form--required" *ngIf="this.errorText">
  <app-error-message [text]="this.errorText"></app-error-message>
</div>
